import { uniqueId } from 'lodash';
import { url } from 'configs/';
import companyRuleIcon from '../../images/links/tube/icn_company_policies.png';
import deptAnnounceIcon from '../../images/links/tube/icn_department_announcement.png';
import assignmentIcon from '../../images/links/tube/icn_assigned_work.png';
import internalLinksIcon from '../../images/links/tube/icn_internal_link.png';
import newsIcon from '../../images/links/tube/icn_news.png';
import notesIcon from '../../images/links/tube/icn_notes.png';
import orderIcon from '../../images/links/tube/icn_order.png';
import stayfunIcon from '../../images/links/tube/icn_stayfun.png';
import mayoFormIcon from '../../images/links/tube/icn_mayoform.png';
import mayoReportIcon from '../../images/links/tube/icn_mayoreport.png';
import bonusCalcIcon from '../../images/links/tube/icn_bonuscalc.png';

const module = 'NewTube';
const baseUrl = url.NEWTUBE_API_SERVER;

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_CompanyPolicies',
    icon: companyRuleIcon,
    url: '/tube/companyrules',
    messageApi: null,
    sort: 7,
    functionCode: ['CompanyRuleEmp', 'CompanyRuleHR'],
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_DeptAnnouncement',
    icon: deptAnnounceIcon,
    url: '/tube/departmentnews',
    messageApi: `${baseUrl}announcement/department`,
    sort: 8,
    functionCode: [
      'DepartmentNewsEmp',
      'DepartmentNewsHR',
      'DepartmentNewsSup',
      'DepartmentNewsSec',
    ],
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_NewsMsg',
    icon: newsIcon,
    url: '/tube/companynews',
    messageApi: `${baseUrl}announcement/company`,
    sort: 9,
    functionCode: ['AnnouncementEmp', 'AnnouncementHR'],
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_NewOrder',
    icon: orderIcon,
    url: '/tube/orders/',
    messageApi: `${baseUrl}orders/unfinished`,
    sort: 10,
    functionCode: ['OrderEmp', 'OrderHR'],
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_Todo',
    icon: assignmentIcon,
    url: '/tube/assignmenttask/',
    messageApi: `${baseUrl}assignment/tome`,
    sort: 13,
    functionCode: 'AssignmentTask',
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_Sticker',
    icon: notesIcon,
    url: '/tube/stickynotes/',
    messageApi: `${baseUrl}postnote/received/unread`,
    sort: 14,
    functionCode: 'Note',
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_InternalLink',
    icon: internalLinksIcon,
    url: '/tube/internallinks',
    messageApi: null,
    sort: 16,
    functionCode: 'InternalSystemLink',
  },
  {
    id: 'mayoForm',
    module: 'mayoForm',
    i18nKey: 'MAYO Form', // 各種語系都相同所以不出多語系，直接由前端寫死
    icon: mayoFormIcon,
    url: '',
    messageApi: `${baseUrl}BpmBridge/FormApprove/UnsignedCount?targetBpm=mayoform`,
    sort: 23,
    functionCode: ['MayoFormPersonal', 'MayoFormHR'],
  },
  {
    id: 'mayoReport',
    module: 'mayoReport',
    i18nKey: 'MAYO Report', // 各種語系都相同所以不出多語系，直接由前端寫死
    icon: mayoReportIcon,
    url: '',
    messageApi: null,
    sort: 24,
    functionCode: ['MAYOReportHR', 'MAYOReportSup', 'MAYOReportSec'],
  },
  {
    // OPTI-134 檔期津貼（BonusCalc）：僅授權清單含 BonusCalc 的使用者可見（功能權限清單
    // 20260717_預計0729上版用：module=NewTube、FunctionCode=BonusCalc、客制/RFC）。
    // i18nKey=FD_BonusCalc 為語言包 key（v2026-00031），與 functionCode 是兩套命名。
    // url 留空、改由 Index.js handleBonusCalcClick 開啟 url.BONUS_CALC_WEBSITE（OPTI-142）——
    // BonusCalc 同網域自行驗證 Asia Cookie，不經 GetFlowUrl 換票。
    id: 'bonusCalc',
    module,
    i18nKey: 'FD_BonusCalc',
    icon: bonusCalcIcon,
    url: '',
    messageApi: null,
    sort: 25,
    functionCode: 'BonusCalc',
  },
  {
    id: 'Stayfun',
    module: 'Stayfun',
    i18nKey: 'STAYFUN',
    icon: stayfunIcon,
    url: 'https://stayfun.mayohr.com/Account/Signin?UrlParameter=https%3A%2F%2Fstayfun.mayohr.com%2F',
    messageApi: null,
    sort: 26, // STAYFUN 永遠最後（OPTI-134 檔期津貼插入 25）
    onlySupervisor: false,
  },
];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/config/links/tube.js
 **/